export default __webpack_public_path__ + "/public/icons/hospital.avif";